// Which side of an exchange a transfer landed on, if either.
//
// Lives in its own file, importing nothing, so both the browser and Node can
// use it: the whale panel renders this, and the whale alert bot posts
// about it. A second copy would drift, and the two would then disagree about
// what counts as an exchange inflow.
//
// `direction` is from the wallet's point of view: "received" means coins
// arrived at that address, "sent" means they left it. A transfer with both is
// an exchange moving coins between its own wallets, which is not flow at all.
//
// "moved" - the wallet spends and is paid back in the same transaction - counts
// as sent. That is what every withdrawal from a hot wallet looks like: it pays a
// batch of customers and sends its change back to its own address. Ignoring it
// meant the Binance hot wallet's deposits read "onto Binance" and not one of its
// 46 most recent withdrawals read "off", so the panel showed hundreds of BTC in
// and exactly zero out. The change is not counted as flow: callers size the
// transfer with netMovedSats, which already leaves change out, so a wallet that
// only pays itself moves nothing.

export const exchangeFlowOf = (tags) => {
  const exchanges = tags.filter((tag) => tag.category === "Exchange");
  if (exchanges.length === 0) return null;

  const inbound = exchanges.find((tag) => tag.direction === "received");
  const outbound = exchanges.find(
    (tag) => tag.direction === "sent" || tag.direction === "moved"
  );

  // `from` is carried only on an internal move, where naming one side is not
  // enough: a hot wallet refilling cold storage and a wallet talking to itself
  // are the same tone, and the whale alert bot has to tell them apart to say
  // which way the coins went. The panel ignores it - it hides internal moves,
  // because they are not flow in either direction.
  if (inbound && outbound)
    return { tone: "internal", tag: inbound, from: outbound };
  if (inbound) return { tone: "in", tag: inbound };
  if (outbound) return { tone: "out", tag: outbound };
  return null;
};
